import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/hr/501/',
    component: ComponentCreator('/hr/501/', '607'),
    exact: true
  },
  {
    path: '/hr/articles/',
    component: ComponentCreator('/hr/articles/', '3df'),
    exact: true
  },
  {
    path: '/hr/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/hr/articles/2024/07/09/diskusija-lj-nj-cyrl/', 'c50'),
    exact: true
  },
  {
    path: '/hr/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/hr/articles/2024/07/09/diskusija-lj-nj/', '495'),
    exact: true
  },
  {
    path: '/hr/articles/archive/',
    component: ComponentCreator('/hr/articles/archive/', '985'),
    exact: true
  },
  {
    path: '/hr/articles/authors/',
    component: ComponentCreator('/hr/articles/authors/', 'e63'),
    exact: true
  },
  {
    path: '/hr/search/',
    component: ComponentCreator('/hr/search/', '0d7'),
    exact: true
  },
  {
    path: '/hr/',
    component: ComponentCreator('/hr/', '4e1'),
    exact: true
  },
  {
    path: '/hr/',
    component: ComponentCreator('/hr/', '175'),
    routes: [
      {
        path: '/hr/',
        component: ComponentCreator('/hr/', '717'),
        routes: [
          {
            path: '/hr/tags/',
            component: ComponentCreator('/hr/tags/', 'ede'),
            exact: true
          },
          {
            path: '/hr/tags/comparative/',
            component: ComponentCreator('/hr/tags/comparative/', 'cdc'),
            exact: true
          },
          {
            path: '/hr/tags/gramatika/',
            component: ComponentCreator('/hr/tags/gramatika/', 'd89'),
            exact: true
          },
          {
            path: '/hr/tags/grammar/',
            component: ComponentCreator('/hr/tags/grammar/', '982'),
            exact: true
          },
          {
            path: '/hr/tags/interslavic/',
            component: ComponentCreator('/hr/tags/interslavic/', 'cfd'),
            exact: true
          },
          {
            path: '/hr/tags/language-learning/',
            component: ComponentCreator('/hr/tags/language-learning/', '136'),
            exact: true
          },
          {
            path: '/hr/tags/linguistics/',
            component: ComponentCreator('/hr/tags/linguistics/', '5cb'),
            exact: true
          },
          {
            path: '/hr/tags/meduslavenski-jezik/',
            component: ComponentCreator('/hr/tags/meduslavenski-jezik/', '509'),
            exact: true
          },
          {
            path: '/hr/tags/meduslavenski/',
            component: ComponentCreator('/hr/tags/meduslavenski/', 'e80'),
            exact: true
          },
          {
            path: '/hr/tags/personal-pronouns/',
            component: ComponentCreator('/hr/tags/personal-pronouns/', '9d4'),
            exact: true
          },
          {
            path: '/hr/tags/pronouns/',
            component: ComponentCreator('/hr/tags/pronouns/', 'bd7'),
            exact: true
          },
          {
            path: '/hr/tags/slavic-languages/',
            component: ComponentCreator('/hr/tags/slavic-languages/', '718'),
            exact: true
          },
          {
            path: '/hr/tags/ucenje-jezika/',
            component: ComponentCreator('/hr/tags/ucenje-jezika/', 'a41'),
            exact: true
          },
          {
            path: '/hr/tags/usporedba-jezika/',
            component: ComponentCreator('/hr/tags/usporedba-jezika/', '5fc'),
            exact: true
          },
          {
            path: '/hr/tags/zamjenice/',
            component: ComponentCreator('/hr/tags/zamjenice/', 'd19'),
            exact: true
          },
          {
            path: '/hr/',
            component: ComponentCreator('/hr/', '0ce'),
            routes: [
              {
                path: '/hr/learn/faq/',
                component: ComponentCreator('/hr/learn/faq/', 'ce7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/',
                component: ComponentCreator('/hr/learn/grammar/', '433'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/adjectives/',
                component: ComponentCreator('/hr/learn/grammar/adjectives/', 'b66'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/conjunctions/',
                component: ComponentCreator('/hr/learn/grammar/conjunctions/', '55d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/nouns/',
                component: ComponentCreator('/hr/learn/grammar/nouns/', 'c1b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/numerals/',
                component: ComponentCreator('/hr/learn/grammar/numerals/', '6be'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/prepositions/',
                component: ComponentCreator('/hr/learn/grammar/prepositions/', 'b6e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/pronouns/',
                component: ComponentCreator('/hr/learn/grammar/pronouns/', '5c0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/syntax/',
                component: ComponentCreator('/hr/learn/grammar/syntax/', 'f87'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/grammar/verbs/',
                component: ComponentCreator('/hr/learn/grammar/verbs/', '3a5'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/introduction/',
                component: ComponentCreator('/hr/learn/introduction/', '7d8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/hr/learn/misc/constructed-slavic-languages/', '7cf'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/design-criteria/',
                component: ComponentCreator('/hr/learn/misc/design-criteria/', '6de'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/history/',
                component: ComponentCreator('/hr/learn/misc/history/', 'ef0'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/language-comparison/',
                component: ComponentCreator('/hr/learn/misc/language-comparison/', 'fb2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/numbers-1-10/',
                component: ComponentCreator('/hr/learn/misc/numbers-1-10/', '473'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/hr/learn/misc/pan-slavic-relay/', '97b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/misc/personal-pronouns/',
                component: ComponentCreator('/hr/learn/misc/personal-pronouns/', 'adb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/orthography/',
                component: ComponentCreator('/hr/learn/orthography/', '4c6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/phonology/',
                component: ComponentCreator('/hr/learn/phonology/', '51d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/pronunciation/',
                component: ComponentCreator('/hr/learn/pronunciation/', 'b11'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/simple-grammar/',
                component: ComponentCreator('/hr/learn/simple-grammar/', 'ebb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/simple-grammar/level-1/',
                component: ComponentCreator('/hr/learn/simple-grammar/level-1/', 'e55'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/simple-grammar/level-2/',
                component: ComponentCreator('/hr/learn/simple-grammar/level-2/', '7d9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/vocabulary/derivation/',
                component: ComponentCreator('/hr/learn/vocabulary/derivation/', 'b31'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/hr/learn/vocabulary/flavourisation/', 'ef3'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/learn/vocabulary/word-formation/',
                component: ComponentCreator('/hr/learn/vocabulary/word-formation/', '187'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/hr/resources/',
                component: ComponentCreator('/hr/resources/', 'c8b'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/hr/resources/applets/',
                component: ComponentCreator('/hr/resources/applets/', '029'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/hr/resources/applets/intelligibility/',
                component: ComponentCreator('/hr/resources/applets/intelligibility/', 'cd0'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/hr/resources/applets/transliterator/',
                component: ComponentCreator('/hr/resources/applets/transliterator/', 'e41'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/hr/resources/keyboards/',
                component: ComponentCreator('/hr/resources/keyboards/', 'f07'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
